import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

/**
 * A native file input whose "choose file" button looks like a secondary
 * Button. Without this the browser button has no border or fill after the
 * CSS reset, so it reads as plain text and nobody finds it.
 */
export const FileInput = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>
>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    type="file"
    className={cn(
      'block w-full text-sm text-muted disabled:opacity-50',
      'file:mr-3 file:h-9 file:cursor-pointer file:rounded-[9px] file:border file:border-solid file:border-border',
      'file:bg-white file:px-3 file:text-sm file:font-medium file:font-[inherit] file:text-text hover:file:bg-bg',
      className,
    )}
    {...props}
  />
));
FileInput.displayName = 'FileInput';
